"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _i18next = _interopRequireDefault(require("i18next"));
var _reactI18next = require("react-i18next");
var _i18nextHttpBackend = _interopRequireDefault(require("i18next-http-backend"));
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
_moment.default.locale("de");
_i18next.default.use(_i18nextHttpBackend.default).use(_reactI18next.initReactI18next).init({
  backend: {
    loadPath: "/locales/{{lng}}/translation.json?v=".concat(new Date().getTime(), "}")
  },
  fallbackLng: "de",
  interpolation: {
    escapeValue: false
  },
  react: {
    useSuspense: false
  }
});
var _default = exports.default = _i18next.default;